<div class="container-fluid">
  <app-page-header
    icon="fe-users"
    pretitle="Registo"
    title="Clientes"
    description="As pessoas que participam, reclamam ou são parte interessada nas ocorrências — e as organizações a que pertencem."
  >
    @if (auth.can('client:write')) {
      <a actions class="btn btn-white" [routerLink]="['novo']">
        <i class="fe fe-plus me-1"></i> Novo cliente
      </a>
    }
  </app-page-header>
</div>

<div class="container-fluid">
  <!-- Tiles de resumo -->
  <div class="row">
    @for (tile of tiles(); track tile.label) {
      <div class="col-12 col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <span class="kpi-icon kpi-icon--{{ tile.tone }}"><i class="fe {{ tile.icon }}"></i></span>
              <div class="ms-3">
                <h6 class="text-uppercase text-muted mb-1">{{ tile.label }}</h6>
                <span class="h2 mb-0">{{ tile.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Filtros -->
  <div class="card">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-12 col-md-8">
          <label class="form-label small text-muted">Procurar</label>
          <input class="form-control" [(ngModel)]="q" (ngModelChange)="onSearch()" placeholder="Nome, e-mail ou empresa" />
        </div>
        <div class="col-12 col-md-4">
          <label class="form-label small text-muted">Situação</label>
          <select class="form-select" [(ngModel)]="status" (ngModelChange)="load()">
            <option [ngValue]="null">Todos</option>
            @for (o of statusOptions; track o.value) { <option [ngValue]="o.value">{{ o.label }}</option> }
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela -->
  <div class="card">
    <div class="card-body p-0">
      @if (error()) {
        <p class="text-danger text-center py-5 mb-0">{{ error() }}</p>
      } @else if (loading()) {
        <p class="text-muted text-center py-5 mb-0">A carregar…</p>
      } @else if (total() === 0) {
        <div class="text-center py-6 px-4">
          <span class="avatar avatar-lg mb-3">
            <span class="avatar-title fs-1 rounded-circle bg-primary-soft text-primary"><i class="fe fe-users"></i></span>
          </span>
          @if (q || status) {
            <h4 class="mb-1">Nenhum cliente com esta busca</h4>
            <p class="text-muted small mb-0">Experimente outro termo ou volte a "Todos".</p>
          } @else {
            <h4 class="mb-1">Ainda não há clientes</h4>
            <p class="text-muted small mb-3">Os clientes são os solicitantes dos chamados — pode criá-los aqui ou deixá-los nascer do primeiro chamado.</p>
            <a class="btn btn-sm btn-primary" routerLink="novo"><i class="fe fe-plus me-1"></i>Novo cliente</a>
          }
        </div>
      } @else {
        <!-- Diretório de pessoas: avatar CÍRCULO -->
        <div class="list-group list-group-flush">
          @for (c of clients(); track c.id) {
            <div class="list-group-item" [routerLink]="[c.id]" style="cursor: pointer;">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="avatar avatar-sm">
                    <span class="avatar-title rounded-circle client-avatar">{{ c.name.charAt(0).toUpperCase() }}</span>
                  </span>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1">{{ c.name }}</h4>
                  <p class="card-text small text-muted mb-0 text-truncate">
                    <i class="fe fe-mail me-1"></i>{{ c.email }}
                    @if (c.company) { <span class="mx-2">·</span><i class="fe fe-briefcase me-1"></i>{{ c.company }} }
                  </p>
                </div>
                @if (c.phone) {
                  <div class="col-auto d-none d-lg-block">
                    <span class="small text-muted"><i class="fe fe-phone me-1"></i>{{ c.phone }}</span>
                  </div>
                }
                <div class="col-auto">
                  <span class="badge" [class]="statusBadge(c.status)">{{ statusLabels[c.status] }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    @if (total() > pageSize) {
      <app-pagination
        [total]="total()"
        [page]="page()"
        [pageSize]="pageSize"
        (pageChange)="onPage($event)"
      />
    }
  </div>
</div>
